import appConfig from '../../configs/appConfig';
import iapClientService from '../iap/iapClientService';
import pushNotificationService from '../pushNotificationService';
import defaultLocalizationDictionariesService from './defaultLocalizationDictionaries/defaultLocalizationDictionariesService';
import localizationCountryService from './localizationCountryService';
import localizationLanguageService from './localizationLanguageService';
import localizationService from './localizationService';

const fetchLocalizationDictionary = (localizationFileName) => {
    if (!localizationFileName) return;

    return iapClientService.getIapLocalization({localizationFileName});
};

const getLocalization = async (countryCode, languageCode) => {
    const language = localizationLanguageService.handleLanguageCode(languageCode);
    const localizationFileName = appConfig.getLocalizationFileNameIfItSupported(countryCode, language);

    if (localizationFileName) {
        return fetchLocalizationDictionary(localizationFileName);
    }
};

const setLocalization = ({countryCode, languageCode, dictionary}) => {
    const language = localizationLanguageService.handleLanguageCode(languageCode);
    const localizationFileName = appConfig.getLocalizationFileNameIfItSupported(countryCode, language);

    localizationService.applyNewLocalizationData(localizationFileName, dictionary);
    pushNotificationService.updateSubscriptionLocalization(language);
    localizationLanguageService.saveLanguageCodeToStorage(languageCode);
};

const setDefaultLocalizationFromApi = async () => {
    const countryCode = localizationCountryService.getUserCountryCodeFromLocalStorage();
    const languageCode = appConfig.getDefaultLanguageCode(countryCode);
    const localizationFileName = appConfig.getMarketDefaultLocalizationName(countryCode);

    const dictionary = await fetchLocalizationDictionary(localizationFileName);

    if (!dictionary) {
        throw new Error('localizationDataService: Failed to get default localization from API');
    }

    setLocalization({countryCode, languageCode, dictionary});
};

const setDefaultLocalizationFromCode = async () => {
    const countryCode = localizationCountryService.getUserCountryCodeFromLocalStorage();
    const languageCode = appConfig.getDefaultLanguageCode(countryCode);
    const dictionary = defaultLocalizationDictionariesService.getDefaultDictionaryFromCode(languageCode);

    setLocalization({countryCode, languageCode, dictionary});
};

export default {
    getLocalization,
    setLocalization,
    setDefaultLocalizationFromApi,
    setDefaultLocalizationFromCode,
};
